import React, { useEffect, useState } from "react";
import { Grid, CircularProgress } from "@mui/material";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../../../firebase/firebase";
import CarruselDestacados from "./CarruselDestacados";
import { useResponsive } from "../../../../Modulo_Responsive/Hooks/useResponsive";

const ListaBebidas = () => {
    const { sCell } = useResponsive();
    const [imagenes, setImagenes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [hayDestacados, setHayDestacados] = useState(false);

    useEffect(() => {
        const fetchImagenes = async () => {
            try {
                const querySnapshot = await getDocs(collection(db, "bebidas"));
                const data = querySnapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                }));
                // mismo sort consistente que ListaMenu y ListaHelado
                data.sort((a, b) => {
                    if (a.orden !== undefined && b.orden !== undefined) return a.orden - b.orden;
                    if (a.numero !== undefined && b.numero !== undefined) return a.numero - b.numero;
                    return 0;
                });
                setImagenes(data);
            } catch (error) {
                console.error("❌ Error cargando imágenes de bebidas:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchImagenes();
    }, []);

    if (loading) {
        return (
            <Grid container justifyContent="center" alignItems="center" sx={{ width: "100%", minHeight: "100vh" }}>
                <CircularProgress />
            </Grid>
        );
    }

    return (
        <Grid
            container
            size={{ xs: 12, sm: 12, md: 12 }}
            justifyContent="center"
            alignItems={'flex-start'}
            sx={{ width: "100%", minHeight: "100vh" }}
            spacing={0}
        >
            <CarruselDestacados
                coleccion="bebidas-destacados"
                coleccionTitulo="bebidas-titulo-destacados"
                titulo="Bebidas destacadas"
                onCargado={setHayDestacados}
            />

            {imagenes.map((img) => (
                <Grid
                    container
                    alignItems={'flex-start'}
                    size={{ xs: 12, sm: 12, md: 12 }}
                    key={img.id}
                    sx={{ display: "flex", justifyContent: "center" }}
                >
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{ xs: 12, sm: 8, md: 5 }}
                        sx={img === imagenes[0] && !hayDestacados ? { pt: sCell ? 9 : 12 } : {}}
                    >
                        <img
                            src={img.url}
                            alt={img.nombre || "imagen bebida"}
                            style={{ width: "100%" }}
                        />
                    </Grid>
                </Grid>
            ))}
        </Grid>
    );
};

export default ListaBebidas;